var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btnitem",on:{"click":_vm.invitation}},[_c('img',{staticStyle:{"width":"19px","height":"19px"},attrs:{"src":require("@/assets/linshiyonggong/shenqin.png")}}),_c('span',[_vm._v("加盟")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }